<template>
	<div class="placeholder-vue header-placeholder">
		<div class="placeholder-nav-section left-placeholder">
			<div class="placeholder-bar name-placeholder"></div>
			<div class="placeholder-bar points-placeholder"></div>
		</div>
		<div class="placeholder-nav-section center-placeholder">
			<!-- TODO make this configurable -->
			<!-- <img alt="store logo site loading image" class="placeholder-logo" src="../../assets/store-logo.png"> -->
			<div class="placeholder-bar location-placeholder"></div>
		</div>
		<div class="placeholder-nav-section right-placeholder">
			<div class="placeholder-bar cart-placeholder"></div>
		</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import { APP_STORE } from '@/stores/defs';
	import Velocity from 'velocity-animate';
	import 'velocity-animate/velocity.ui.min';
	export default {
		data() {
			return {
				headerLoaded: () => {
					return this.customerFetchDone;
				}
			}
		},
		computed: {
			...mapGetters({
				customerFetchDone: APP_STORE.LOADED,
			}),
		},
		methods: {
			removePlaceholder() {
				const placeholderElement = this.$el;
				Velocity(placeholderElement, {
					opacity: 0,
				}, {
					duration: 544,
					complete: () => {
						this.hidePlaceholder();
					}
				});
			},
			hidePlaceholder() {
				const placeholderElement = this.$el;
				placeholderElement.style.display = 'none';
			}
		},
		watch: {
			customerFetchDone(newValue, oldValue) {
				if (newValue && !oldValue) {
					this.removePlaceholder();
				}
			}
		},
		mounted() {
			if (this.customerFetchDone) {
				this.hidePlaceholder();
			}
		},
	}
</script>

<style lang="scss" scoped>
	@import 'globalStyles';
	.header-placeholder {
		display: flex;
		position: absolute;
		opacity: 1;
		top: 0;
		left: 0;
		width: 100vw;
		height: $navigationBarHeight;
		background-color: white;
		z-index: $zTopInteractionLayer + 1;
		.placeholder-nav-section {
			display: flex;
			flex-direction: column;
			height: $navigationBarHeight;
			flex: 1;
		}
		.placeholder-bar {
			position: relative;
			top: 0.5em;
			margin-bottom: 4px;

			width: 56%;
			height: 1.2em;

			background-color: grey;
		}
		.left-placeholder {
			.placeholder-bar {
				left: 0.5em;
			}
		}
		.center-placeholder {
			text-align: center;
			.placeholder-bar {
				width: 100%;
				height: calc(100% - 20px);
			}
		}
		.right-placeholder {
			.placeholder-bar {
				align-self: flex-end;
				right: 0.5em;
				left: inherit;
			}
			.cart-placeholder {
				height: 2.8em;
				width: 10em;
				border-radius: 1em;
			}
		}
		.placeholder-logo {
			margin: auto;
			margin-top: 0.5em;

			max-width: 168px;
			max-height: 5em;

			object-fit: contain;
		}
	}
	@include mobile {
		.header-placeholder {
			height: $mobileNavigationHeight;
			.placeholder-nav-section {
				height: $mobileNavigationHeight - 1;
			}
			.placeholder-bar {
				top: 0.4em;
			}
			.right-placeholder {
				.cart-placeholder {
					width: 5em;
					right: 0.4em;
				}
			}
			.placeholder-logo {
				margin-top: 0.8em;

				max-width: 115px;
				max-height: $mobileNavigationHeight/2;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/header/HeaderPlaceholder.vue